import {Component, input, model} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';
import {FloatLabel} from 'primeng/floatlabel';
import {SelectModule} from 'primeng/select';
import {SelectOption, SelectValue} from './options-select.types';

let nextInputId = 0;

@Component({
  selector: 'app-options-select',
  imports: [FormsModule, NgTemplateOutlet, TranslocoPipe, FloatLabel, SelectModule],
  templateUrl: './options-select.component.html',
})
export class OptionsSelectComponent<T extends string | number = string | number> {
  readonly options = input.required<SelectOption<T>[]>();
  readonly placeholder = input.required<string>();
  readonly label = input<string | null>(null);
  readonly disabled = input(false);
  readonly styleClass = input('w-full');
  readonly testId = input('');

  readonly value = model<SelectValue<T>>();

  protected readonly inputId = `options-select-${nextInputId++}`;
}
